import React from "react";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";

// State
import store from "./redux/store";
import Routes from "./routes/Routes";
import { loadUser } from "./redux/actions/userActions";

import { warn } from "./utils/logger";
import { USER_TOKEN_NAME } from "./redux/constants";

// Set API Defaults
import { setAxiosConfig } from "./utils/axiosConfig";
setAxiosConfig();

// If client has a saved token - save token to Authorization headers for subsequent calls
const authToken = localStorage.getItem(USER_TOKEN_NAME);
if (authToken) {
  warn("[i] Loading session from storage");
  store.dispatch(loadUser({ token: authToken, from: "token" }));
}

const App = () => (
  <Provider store={store}>
    <Routes />

    <ReduxToastr
      timeOut={5000}
      newestOnTop={true}
      position="top-right"
      transitionIn="fadeIn"
      transitionOut="fadeOut"
      progressBar
      closeOnToastrClick
    />
  </Provider>
);

export default App;
